import { Button, Checkbox, Col, Form, Input, Radio, Row, Select } from "antd";
import { forwardRef, useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

const { Option } = Select;

const EditAdminUser = forwardRef(({ editPopup, menuGroupLists }, userRef) => {
  const [status, setStatus] = useState(editPopup.status);
  const [assignedMenuGroupId, setAssignedMenuGroupId] = useState(
    editPopup.assignedMenuGroupId
  );

  // function validator(_, value) {
  //   const newData = userRef.current.getFieldsValue();

  //   for (let el of dataSource) {
  //     if (el.id !== newData.menuId && el.menu_name === newData.menuName) {
  //       return Promise.reject(
  //         new Error(`메뉴에 "${el.menu_name}"가 이미 존재합니다.`)
  //       );
  //     }
  //   }
  //   return Promise.resolve();
  // }
  // console.log(status);

  function onChangeStatus(value) {
    // console.log(value)
    setStatus(value);
  }
  function onChangeMenuGroup(value) {
    setAssignedMenuGroupId(value);
  }

  return (
    <div>
      <Form
        ref={userRef}
        layout="vertical"
        initialValues={{
          email: editPopup.email,
          name: editPopup.name,
          phone: editPopup.phone,
          department: editPopup.department,
          responsibility: editPopup.responsibility,
          position: editPopup.position,
          assignedMenuGroupId: editPopup.assignedMenuGroupId,
          status: editPopup.status,
          id: editPopup.id,
          description: editPopup.description,
          createAt:
            editPopup.create_user_name + "(" + editPopup.create_datetime + ")",
          updateAt:
            editPopup.update_user_name === null
              ? null
              : editPopup.update_user_name +
                "(" +
                editPopup.update_datetime +
                ")",
        }}
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="id" label="ID" required={true} hidden={true}>
              <Input disabled={true}></Input>
            </Form.Item>
            <Form.Item
              name="email"
              label="계정(이메일)"
              required={true}
              rules={[
                { required: true, message: "이메일은 필수 입력사항입니다." },
                { type: "email", message: "이메일 주소 형식에 맞지 않습니다." },
              ]}
            >
              <Input disabled={true}></Input>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="name"
              label="이름"
              required={true}
              rules={[
                { required: true, message: "이름은 필수 입력사항입니다." },
              ]}
            >
              <Input></Input>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="phone"
              label="휴대폰번호"
              required={true}
              rules={[
                {
                  required: true,
                  message: "휴대폰번호는 필수 입력사항 입니다.",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="department"
              label="소속"
              required={true}
              rules={[
                { required: true, message: "소속은 필수 입력사항입니다." },
              ]}
            >
              <Input></Input>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="responsibility"
              label="직책"
              required={true}
              rules={[
                { required: true, message: "직책은 필수 입력사항입니다." },
              ]}
            >
              <Input></Input>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="position" label="직급">
              <Input></Input>
            </Form.Item>
          </Col>
        </Row>
        <Col>
          <Form.Item
            name="assignedMenuGroupId"
            label="관리영역"
            required={true}
            rules={[
              { required: true, message: "관리영역은 필수 입력사항 입니다." },
            ]}
          >
            <Checkbox.Group
              onChange={onChangeMenuGroup}
              value={assignedMenuGroupId}
            >
              {menuGroupLists.map((ele) => (
                <Row key={ele.id}>
                  <Checkbox value={ele.id}>{ele.menu_group_name}</Checkbox>
                </Row>
              ))}
            </Checkbox.Group>
          </Form.Item>
        </Col>
        <Row>
          <Col span={24}>
            <Form.Item name="description" label="메모">
              <Input.TextArea></Input.TextArea>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Form.Item
            name="status"
            label="계정 상태"
            required={true}
            rules={[
              { required: true, message: "계정상태는 필수 입력사항 입니다." },
            ]}
          >
            <Radio.Group onChange={onChangeStatus} value={status}>
              <Radio value="1">정상</Radio>
              <Radio value="0">해지</Radio>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="createAt" label="최초등록자 및 등록일시">
              <Input disabled={true}></Input>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="updateAt" label="최종수정자 및 수정일시">
              <Input disabled={true}></Input>
            </Form.Item>
          </Col>
        </Row>
        {/* <Form.Item
          name="menuName"
          label="메뉴명칭"
          rules={[
            { required: true, message: "관리메뉴 명칭을 입력해 주세요." },
            { validator: validator },
          ]}
        >
          <Input></Input>
        </Form.Item>
        <Form.Item
          name="menuURL"
          label="메뉴 URL"
          rules={[{ required: true, message: "관리메뉴 URL을 입력해 주세요." }]}
        >
          <Input addonBefore="https://"></Input>
        </Form.Item> */}
      </Form>
    </div>
  );
});

export default EditAdminUser;
